import DsQuestion from './src/main';

/* istanbul ignore next */
DsQuestion.install = function(Vue) {
    Vue.component(DsQuestion.name, DsQuestion);
};

export default DsQuestion;
